// Page copy and media. Demo videos/GIFs live in public/media (regenerate with the
// capture scripts described in public/media/README.md).

export const nav = [
    { href: '#how-it-works', label: 'How it works' },
    { href: '#chair', label: 'Chair view' },
    { href: '#benefits', label: 'Benefits' },
    { href: '#contact', label: 'Contact' },
];

export const voterSignIn = 'https://ievoter.com';

export const hero = {
    title: 'Say goodbye to paper ballots',
    lead: 'Instant Elect runs your conference elections on the phones, tablets and laptops your members already carry. Voters are signed in within seconds, every ballot is anonymous and encrypted, and the chair sees each vote the moment it is cast.',
    primary: { href: '#how-it-works', label: 'See how it works' },
    secondary: { href: '#contact', label: 'Plan an election' },
    origin: 'Built by people who served ten years on tabulating committees, and have supported electronic elections ever since.',
    demo: {
        name: 'voter-keypad-login',
        label: 'A voter types their token, searches “DAV BER”, and confirms a vote for David K. Bernard',
        caption: 'Signing in with the token, searching part of a name, and voting.',
        width: 720,
        height: 1324,
    },
};

export const trust = {
    logo: '/media/upci-logo.png',
    logoAlt: 'United Pentecostal Church International',
    text: 'Chosen for the 2026 UPCI General Conference business meeting.',
};

export const steps = {
    title: 'How it works',
    intro: 'Three steps take a business meeting from the voter card to the final report.',
    setup: {
        title: 'Before the meeting',
        body: 'We load your organization’s rules and eligible candidates, then set up the nominating ballots, electoral ballots and motions. Every qualified voter receives a card with a QR code and a 16‑digit voter token.',
        points: [
            'Candidates who are ineligible, resigned or declined never appear',
            'Term limits and 2/3 majorities are calculated for you',
            'Anonymous voter tokens keep every ballot secret',
        ],
        card: '/media/voter-card.png',
        cardAlt: 'Sample voter card with a QR code and the token 8888 8888 8888 8888',
    },
    voters: {
        title: 'Voters sign in and vote',
        body: 'Most voters are ready in about ten seconds. Scanning the card opens the ballot directly; anyone without a camera can visit ievoter.com and type the token instead.',
        points: [
            { title: 'Search any part of a name', text: '“DAV BER” finds David K. Bernard without scrolling thousands of names.' },
            { title: 'Confirm before it counts', text: 'Every choice asks for confirmation first. Once confirmed, the vote is final and the server returns a receipt.' },
            { title: 'Private by default', text: 'The receipt hides itself after five seconds, and voters can show it again at any time.' },
        ],
        demo: {
            name: 'voter-qr-login',
            label: 'A phone camera scans the QR code on a voter card and opens the ballot, already signed in',
            caption: 'Scanning the voter card opens the ballot, already signed in.',
            width: 1200,
            height: 1044,
        },
    },
    chair: {
        title: 'The chair sees results as they happen',
        body: 'The chair and tabulating committee follow the poll live: status, turnout, time since the last vote, and every candidate’s votes and percentage. When the chair closes the poll, results display instantly and a PDF election report is generated.',
        facts: ['Live turnout and vote counts', 'Term-limit and 2/3 rules applied automatically', 'PDF report the moment the poll closes'],
        demo: {
            name: 'chair-live-results',
            label: 'The chair results screen updating as 100 votes arrive; David K. Bernard finishes with 72 percent',
            caption: '100 votes arriving in the chair view, with the incumbent’s 2/3 threshold tracked.',
            width: 1200,
            height: 900,
        },
    },
};

export const benefits = {
    title: 'Fewer errors, faster results',
    blocks: [
        {
            title: 'No wasted votes',
            text: 'Unqualified candidates, and those who have resigned or declined, never appear on the ballot.',
        },
        {
            title: 'No rule-based mistakes',
            text: 'Term-limit procedure and simple or 2/3 majority polls are calculated automatically.',
        },
        {
            title: 'No doubt a vote counted',
            text: 'Voters receive instant confirmation showing the candidate’s name, city and state.',
        },
        {
            title: 'Instant results',
            text: 'The chair and tabulating committee watch results in real time, and final results display the moment polls close.',
        },
        {
            title: 'Automatic reporting',
            text: 'The headquarters representative and district superintendent receive the election report when the election concludes.',
        },
    ],
};

export const contact = {
    title: 'Plan your next election',
    detail: 'Tell us about your meeting and we’ll respond as quickly as possible.',
    phones: [
        { label: 'Office', number: '(601) 633-9090' },
        { label: 'Mobile', number: '(503) 805-9960' },
    ],
    email: 'admin@instantelect.com',
    btn: 'Send message',
    sending: 'Sending…',
    sent: 'Message sent. We’ll be in touch soon.',
    failed: 'Your message wasn’t sent. Please try again, or email admin@instantelect.com.',
    botCheck: 'Please complete the bot check before sending.',
    tooMany: 'Too many attempts from your connection. Please wait ten minutes and try again, or email admin@instantelect.com.',
};

export const footer = {
    footerLogo: require('../../assets/images/footer-logo.svg').default,
    alt: 'Instant Elect',
};
